import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllRelationships = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetRelations}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getRelationshipById = async ({ companyCode,code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.RelationshipAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertRelationship = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.RelationshipAPI, input);
  return data;
};

const updateRelationship = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.RelationshipAPI, input);
  return data;
};

const deleteRelationship = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.RelationshipAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetRelationshipsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetRelations],
    queryFn: () => getAllRelationships(input),
  });
};

export const useGetRelationshipByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.RelationshipAPI],
    queryFn: () => getRelationshipById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertRelationshipMutation = () => {
  return useMutation({
    mutationFn: insertRelationship,
  });
};

export const useUpdateRelationshipMutation = () => {
  return useMutation({
    mutationFn: updateRelationship,
  });
};

export const useDeleteRelationshipMutation = () => {
  return useMutation({
    mutationFn: deleteRelationship,
  });
};
